import { render, staticRenderFns } from "./custommap.vue?vue&type=template&id=2caca80c&scoped=true&"
import script from "./custommap.vue?vue&type=script&lang=js&"
export * from "./custommap.vue?vue&type=script&lang=js&"
import style0 from "./custommap.vue?vue&type=style&index=0&id=2caca80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caca80c",
  null
  
)

export default component.exports